import { render, staticRenderFns } from "./form-section.vue?vue&type=template&id=62328135&scoped=true"
import script from "./form-section.vue?vue&type=script&lang=js"
export * from "./form-section.vue?vue&type=script&lang=js"
import style0 from "./form-section.vue?vue&type=style&index=0&id=62328135&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62328135",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62328135')) {
      api.createRecord('62328135', component.options)
    } else {
      api.reload('62328135', component.options)
    }
    module.hot.accept("./form-section.vue?vue&type=template&id=62328135&scoped=true", function () {
      api.rerender('62328135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/form-section/form-section.vue"
export default component.exports